import { styled } from '@mui/material/styles';
import { Icon, ListItemIcon, Popper } from '@mui/material';

export const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: 35,
  color: theme.palette.secondary.main,
}));

export const Title = styled('div')(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  flexDirection: 'row',
  alignItems: 'center',
  display: 'flex',
}));

export const StyledPopper = styled(Popper)(({ theme }) => ({
  zIndex: 100000,
  backgroundColor: theme.palette.background.paper,
  boxShadow: '2px 2px 4px rgba(0,0,0,0.5)',
}));

export const TriggerIcon = styled(Icon)(({ theme }) => ({
  color: theme.palette.text.primary,
}));
